import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Lock } from 'lucide-react';

const DEV_PASSWORD = 'advokat2025'; // Simple password for development

const DevAuth = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if already authorized
    const auth = localStorage.getItem('dev_auth');
    if (auth === DEV_PASSWORD) {
      setIsAuthorized(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === DEV_PASSWORD) {
      localStorage.setItem('dev_auth', DEV_PASSWORD);
      setIsAuthorized(true);
      setError('');
    } else {
      setError('Feil passord');
      setPassword('');
    }
  };

  if (isAuthorized) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-3xl border-2 border-gray-200 shadow-2xl p-10">
          <div className="w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Lock className="w-8 h-8 text-white" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
            Utvikler-tilgang
          </h1>
          <p className="text-gray-600 text-center mb-8">
            Dette er prototype-appen. Skriv inn passord for tilgang.
          </p>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="password"
              placeholder="Utvikler-passord"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              className="h-14 text-base rounded-xl border-gray-300"
              autoFocus
            />
            {error && (
              <p className="text-sm text-red-600 text-center">{error}</p>
            )}
            <Button 
              type="submit" 
              className="w-full bg-gray-900 hover:bg-gray-800 h-14 text-base font-bold rounded-xl"
            >
              Lås opp
            </Button>
          </form>
          
          <p className="text-xs text-gray-500 text-center mt-6">
            Hint: advokat2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default DevAuth;
